import { render, staticRenderFns } from "./BuyOrdersRefer.vue?vue&type=template&id=00bcd1ec&"
import script from "./BuyOrdersRefer.vue?vue&type=script&lang=js&"
export * from "./BuyOrdersRefer.vue?vue&type=script&lang=js&"
import style0 from "./BuyOrdersRefer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports